(function () {
  var spotlightSwipers = {};

  function destroySpotlight(sectionId) {
    if (spotlightSwipers[sectionId]) {
      spotlightSwipers[sectionId].destroy(
        true,
        true
      );

      delete spotlightSwipers[sectionId];
    }
  }

  function initSpotlight(sectionId) {
    var sectionEl = document.getElementById(
      'product-spotlight-' + sectionId
    );

    if (!sectionEl) {
      return;
    }

    var swiperEl = sectionEl.querySelector(
      '.product-spotlight__swiper'
    );

    var prevButton = sectionEl.querySelector(
      '.product-spotlight__arrow--prev'
    );

    var nextButton = sectionEl.querySelector(
      '.product-spotlight__arrow--next'
    );

    var paginationEl = sectionEl.querySelector(
      '.product-spotlight__pagination'
    );

    var mobileColumns =
      parseInt(
        sectionEl.getAttribute('data-mobile-columns'),
        10
      ) || 2;

    if (!swiperEl) {
      return;
    }

    if (window.innerWidth >= 750) {
      destroySpotlight(sectionId);
      return;
    }

    if (typeof Swiper === 'undefined') {
      return;
    }

    destroySpotlight(sectionId);

    spotlightSwipers[sectionId] =
      new Swiper(swiperEl, {
        slidesPerView: mobileColumns,
        slidesPerGroup: mobileColumns,
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,

        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        },

        pagination: {
          el: paginationEl,
          clickable: true,
          dynamicBullets: false
        }
      });
  }

  function initializeAllSpotlights() {
    var sections = document.querySelectorAll(
      '.product-spotlight-section[data-section-id]'
    );

    if (!sections.length) {
      return;
    }

    function run() {
      sections.forEach(function (sectionEl) {
        var sectionId = sectionEl.getAttribute(
          'data-section-id'
        );

        initSpotlight(sectionId);
      });
    }

    if (typeof Swiper !== 'undefined') {
      run();
    } else {
      document.addEventListener(
        'swiper:ready',
        run,
        { once: true }
      );
    }
  }

  var resizeTimer;

  function handleResize() {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(function () {
      initializeAllSpotlights();
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllSpotlights
    );
  } else {
    initializeAllSpotlights();
  }

  window.addEventListener('resize', handleResize);

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      var sectionEl = event.target.querySelector(
        '.product-spotlight-section[data-section-id]'
      );

      if (!sectionEl) {
        return;
      }

      var sectionId = sectionEl.getAttribute(
        'data-section-id'
      );

      if (typeof Swiper !== 'undefined') {
        initSpotlight(sectionId);
      } else {
        document.addEventListener(
          'swiper:ready',
          function () {
            initSpotlight(sectionId);
          },
          { once: true }
        );
      }
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      var sectionEl = event.target.querySelector(
        '.product-spotlight-section[data-section-id]'
      );

      if (!sectionEl) {
        return;
      }

      var sectionId = sectionEl.getAttribute(
        'data-section-id'
      );

      destroySpotlight(sectionId);
    }
  );
})();
